<template>
  <div
    class="widget-skeleton-container"
    :class="className"
  >
    <LineChartWidgetSkeleton
      v-if="type === 'lineChart'"
    />
    <SlopeChartWidgetSkeleton
      v-if="type === 'slopeChart'"
      :number-of-lines="numberOfLines"
    />
    <VerticalBarChartWidgetSkeleton
      v-else-if="type === 'verticalBarChart'"
      :number-of-bars="numberOfBars"
    />
    <VerticalStackedBarWidgetSkeleton
      v-else-if="type === 'verticalStackedBarChart'"
    />
    <HorizontalBarChartWidgetSkeleton
      v-else-if="type === 'horizontalBarChart'"
    />
    <HorizontalBenchmarkChartWidgetSkeleton
      v-else-if="type === 'horizontalBenchmarkChart'"
    />
    <DoughnutChartWidgetSkeleton
      v-else-if="type === 'doughnutChart'"
    />
  </div>
</template>

<script setup>
import LineChartWidgetSkeleton from '@/components/insights/skeletonLoaders/chartSkeletons/LineChartWidgetSkeleton.vue';
import VerticalStackedBarWidgetSkeleton from '@/components/insights/skeletonLoaders/chartSkeletons/VerticalStackedBarWidgetSkeleton.vue';
import VerticalBarChartWidgetSkeleton from '@/components/insights/skeletonLoaders/chartSkeletons/VerticalBarChartWidgetSkeleton.vue';
import HorizontalBarChartWidgetSkeleton from '@/components/insights/skeletonLoaders/chartSkeletons/HorizontalBarChartWidgetSkeleton.vue';
import HorizontalBenchmarkChartWidgetSkeleton from '@/components/insights/skeletonLoaders/chartSkeletons/HorizontalBenchmarkChartWidgetSkeleton.vue';
import DoughnutChartWidgetSkeleton from '@/components/insights/skeletonLoaders/chartSkeletons/DoughnutChartWidgetSkeleton.vue';
import SlopeChartWidgetSkeleton from '@/components/insights/skeletonLoaders/chartSkeletons/SlopeChartWidgetSkeleton.vue';

const props = defineProps({
  type: {
    type: String,
    default: '',
  },
  numberOfBars: {
    type: Number,
    default: 0,
  },
  numberOfLines: {
    type: Number,
    default: 3,
  },
  className: {
    type: String,
    default: '',
  },
  widgetLabel: {
    type: String,
    default: '',
  },
});

const {
  type, numberOfBars, numberOfLines, className,
} = props;
</script>

<style scoped lang="less">
.widget-skeleton-container {
  width: 100%;
  height: 100%;
}
</style>
